"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNewsFileStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.useNewsFileStore = (0, pinia_1.defineStore)('newsFileStore', {
    state: () => ({
        loading: false,
        newsFiles: []
    }),
    actions: {
        setLoading(loading) {
            this.loading = loading;
        },
        reset() {
            this.loading = false;
            this.newsFiles = [];
        },
        setNewsFiles(newsFiles) {
            this.newsFiles = newsFiles;
        },
        async getNewsFiles(router, params = {}) {
            this.setLoading(true);
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'admin_news_files_api', query: params }).href);
                const newsFiles = [];
                if (Array.isArray(response['hydra:member'])) {
                    response['hydra:member'].forEach(element => {
                        if (element['@type'] !== 'NewsFile') {
                            return;
                        }
                        newsFiles.push(element);
                    });
                }
                this.setNewsFiles(newsFiles);
                this.setLoading(false);
                return response;
            }
            catch (error) {
                console.error('Error fetching news files:', error);
                this.setLoading(false);
                throw error;
            }
        },
        async saveNewsFile(router, formData) {
            this.setLoading(true);
            const url = router.resolve({ name: 'admin_news_files_api' }).href;
            // DONT ADD HEADERS OPTIONS!!!
            // { "Content-Type": "multipart/form-data" }.
            // It wont work with it. The browser wrap it in WebKitFormBoundary.
            const options = {
                method: 'POST',
                body: formData
            };
            try {
                const response = await (0, fetch_1.default)(url, options);
                this.setLoading(false);
                return response;
            }
            catch (error) {
                console.error('Error saving news file:', error);
                this.setLoading(false);
                throw error;
            }
        },
        async deleteNewsFile(router, newsFile) {
            this.setLoading(true);
            try {
                await (0, fetch_1.default)(router.resolve({
                    name: 'admin_news_files_api',
                    params: {
                        id: (Number(newsFile.id)).valueOf()
                    }
                }).href, { method: 'DELETE' });
                this.setLoading(false);
            }
            catch (error) {
                console.error('Error deleting news file:', error);
                this.setLoading(false);
                throw error;
            }
        }
    }
});
